const WEEKLY_CHECK_IN_CONTENT_VERSION = "2026-08-04.weekly-check-in.v1";

const STANDARD_OPTIONS = [
  {
    value: 0,
    labelKey: "options.standard.noWorseThanUsual",
  },
  {
    value: 1,
    labelKey: "options.standard.aLittleWorseThanUsual",
  },
  {
    value: 2,
    labelKey: "options.standard.clearlyWorseThanUsual",
  },
  {
    value: 3,
    labelKey: "options.standard.muchWorseThanUsual",
  },
];

const PHLEGM_OPTIONS = [
  {
    value: 0,
    labelKey: "options.phlegm.noChangeOrBetter",
  },
  {
    value: 1,
    labelKey: "options.phlegm.smallChange",
  },
  {
    value: 2,
    labelKey: "options.phlegm.clearIncreaseOrChange",
  },
  {
    value: 3,
    labelKey: "options.phlegm.majorChange",
  },
  {
    value: "NA",
    labelKey: "options.phlegm.notUsuallyPresent",
  },
];

const RELIEVER_OPTIONS = [
  {
    value: 0,
    labelKey: "options.reliever.none",
  },
  {
    value: 1,
    labelKey: "options.reliever.oneDay",
  },
  {
    value: 2,
    labelKey: "options.reliever.twoToThreeDays",
  },
  {
    value: 3,
    labelKey: "options.reliever.fourToSevenDays",
  },
  {
    value: "NA",
    labelKey: "options.reliever.notApplicable",
  },
];

function normalizeConditionValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function hasBronchiectasisCondition(value) {
  return /bronchiectasis/u.test(normalizeConditionValue(value));
}

function readWeeklyProfile(context) {
  if (context?.profile && typeof context.profile === "object") {
    return context.profile;
  }

  return context && typeof context === "object" ? context : {};
}

function resolveWeeklyCheckInVariant(context) {
  const profile = readWeeklyProfile(context);
  const respiratoryConditions = Array.isArray(profile.respiratoryConditions)
    ? profile.respiratoryConditions
        .map((value) => normalizeConditionValue(value))
        .filter(Boolean)
    : [];
  const respiratoryConditionsOther = normalizeConditionValue(
    profile.respiratoryConditionsOther,
  );
  const hasBronchiectasis = hasBronchiectasisCondition(
    respiratoryConditionsOther,
  );
  const hasCopd = respiratoryConditions.includes("copd");
  const hasAsthma = respiratoryConditions.includes("asthma");
  const hasIld = respiratoryConditions.includes("ild");

  if (hasBronchiectasis) {
    return "productive-airway";
  }

  if (hasCopd) {
    return "productive-airway";
  }

  if (hasAsthma) {
    return "asthma";
  }

  if (hasIld) {
    return "restrictive";
  }

  return "fallback";
}

const matchesWeeklyVariant =
  (...supportedVariants) =>
  (_formData, context) =>
    supportedVariants.includes(resolveWeeklyCheckInVariant(context));

const weeklyCheckInQuestionnaire = [
  {
    id: "RH_WK_BREATHLESSNESS_CHANGE",
    titleKey: "breathlessness.title",
    title: "Breathlessness",
    fieldType: "radio",
    required: true,
    options: STANDARD_OPTIONS,
    group: "weekly-check-in",
  },
  {
    id: "RH_WK_COUGH_CHANGE",
    titleKey: "cough.title",
    title: "Cough",
    fieldType: "radio",
    required: true,
    options: STANDARD_OPTIONS,
    group: "weekly-check-in",
  },
  {
    id: "RH_WK_PHLEGM_CHANGE",
    titleKey: "phlegm.title",
    title: "Phlegm or mucus",
    fieldType: "radio",
    required: true,
    options: PHLEGM_OPTIONS,
    condition: matchesWeeklyVariant("productive-airway"),
    group: "weekly-check-in",
  },
  {
    id: "RH_WK_RELIEVER_INCREASE",
    titleKey: "reliever.title",
    title: "Inhaler use",
    fieldType: "radio",
    required: true,
    options: RELIEVER_OPTIONS,
    condition: matchesWeeklyVariant("asthma"),
    group: "weekly-check-in",
  },
  {
    id: "RH_WK_ACTIVITY_CHANGE",
    titleKey: "activity.title",
    title: "Activities",
    fieldType: "radio",
    required: true,
    options: STANDARD_OPTIONS,
    condition: matchesWeeklyVariant("restrictive", "fallback"),
    group: "weekly-check-in",
  },
];

weeklyCheckInQuestionnaire.metadata = {
  titleKey: "title",
  introKey: "intro",
  contentVersion: WEEKLY_CHECK_IN_CONTENT_VERSION,
};

export default weeklyCheckInQuestionnaire;
